import React from 'react'
import { type Styles } from 'react-select/src/styles'
import { colors } from 'gin-and-tonic/foundation/colors'
import { fontSize } from 'gin-and-tonic/foundation/fontSize'
const ShiftDetailsFormStylesContext = React.createContext({})

function ShiftDetailsFormStylesProvider({ children }) {
  const baseStyles: Styles = {
    control: () => ({
      background: colors.GRAYSCALE.X10,
      borderColor: colors.GRAYSCALE.X10,
      padding: '9px 0px',
    }),
    singleValue: () => ({
      fontSize: fontSize.X15,
      fontWeight: 600,
      lineHeight: '22px',
    }),
    option: () => ({
      fontSize: fontSize.X15,
      fontWeight: 600,
      lineHeight: '22px',
      padding: '20px 10px',
      display: 'flex',
      alignItems: 'center',
    }),
  }

  return (
    <ShiftDetailsFormStylesContext.Provider value={baseStyles}>
      {children}
    </ShiftDetailsFormStylesContext.Provider>
  )
}

function useShiftDetailsFormStyles(overrides: Styles = {}) {
  const styles = React.useContext(ShiftDetailsFormStylesContext)
  if (styles === undefined) {
    throw new Error('useShiftDetailsFormStyle must be used within a ShiftDetailsFormStylesProvider')
  }
  return { ...styles, ...overrides }
}

export { ShiftDetailsFormStylesProvider, useShiftDetailsFormStyles }
